"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentBox = function CommentBox(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      children = _ref.children,
      editHandler = _ref.editHandler,
      dataTestId = _ref.dataTestId,
      deleteHandler = _ref.deleteHandler;
  var IconToRender;

  if (icon !== '') {
    IconToRender = /*#__PURE__*/_react.default.createElement(CommentBoxIcon, null, icon);
  }

  return /*#__PURE__*/_react.default.createElement(CommentBoxWrapper, {
    dataTestId: dataTestId
  }, IconToRender, /*#__PURE__*/_react.default.createElement(CommentBoxContent, null, /*#__PURE__*/_react.default.createElement(CommentBoxHeader, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "title"
  }, title), /*#__PURE__*/_react.default.createElement(CommentBoxActions, null, /*#__PURE__*/_react.default.createElement("span", null, " | "), /*#__PURE__*/_react.default.createElement(CommentBoxAction, {
    onClick: editHandler,
    "data-test-id": "comment_edit"
  }, "Edit"), /*#__PURE__*/_react.default.createElement(CommentBoxAction, {
    onClick: deleteHandler,
    "data-test-id": "comment_delete"
  }, "Delete"))), children));
};

var CommentBoxWrapper = _styledComponents.default.div.withConfig({
  displayName: "CommentBoxWrapper"
})(["display:flex;align-items:flex-start;width:100%;font-family:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var CommentBoxIcon = _styledComponents.default.div.withConfig({
  displayName: "CommentBoxIcon"
})(["margin-right:20px;"]);

var CommentBoxContent = _styledComponents.default.div.withConfig({
  displayName: "CommentBoxContent"
})(["& p{font-size:1.6rem;line-height:120%;color:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.typo.text;
});

var CommentBoxHeader = _styledComponents.default.div.withConfig({
  displayName: "CommentBoxHeader"
})(["display:flex;justify-content:flex-start;align-items:center;margin-bottom:10px;.title{font-size:1.4rem;line-height:120%;color:", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.labels.defaultText;
});

var CommentBoxActions = _styledComponents.default.div.withConfig({
  displayName: "CommentBoxActions"
})(["display:none;justify-content:flex-start;align-items:center;span{margin:0 10px;font-size:1.4rem;line-height:2rem;color:", ";}", ":hover &{display:flex;}", ":focus &{display:flex;}"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.labels.defaultText;
}, CommentBoxWrapper, CommentBoxWrapper);

var CommentBoxAction = _styledComponents.default.a.withConfig({
  displayName: "CommentBoxAction"
})(["margin-right:10px;font-size:1.4rem;line-height:120%;color:", ";cursor:pointer;transition:color 0.1s ease-in-out;&:last-of-type{margin-right:0;}&:hover,&:focus{color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.labels.defaultText;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.brand.primary;
});

CommentBox.propTypes = {
  // used to identify component for testing
  dataTestId: _propTypes.string,

  /** Title displayed next to the actions. */
  title: _propTypes.string,

  /** Icon to be displayed on the left side. */
  icon: _propTypes.node,
  children: _propTypes.node,

  /** Function to be ran when 'edit' is clicked. */
  editHandler: _propTypes.func,

  /** Function to be ran when 'delete' is clicked. */
  deleteHandler: _propTypes.func,
  id: _propTypes.int
};
var _default = CommentBox;
exports.default = _default;